import navBarHomepage from '../modules/navbar-homepage';
import postShareButtons from '../modules/post-share-buttons';
import companyIndex from '../modules/companies';
import micSidebar from '../modules/mic-sidebar';

let companyIndexController = () => {
    // initCarousel ()
    navBarHomepage.on();
    postShareButtons.on();
    companyIndex();
    micSidebar();


};

export default companyIndexController;
